import axios from 'axios'

export const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL
})

export const upload = async file => {
  const data = new FormData()
  data.append('files', file)

  return await axiosClient.post('/media', data, {
    headers: {
      Authorization: window.localStorage.getItem(process.env.REACT_APP_AUTH_STORAGE_KEY),
      'Content-Type': 'multipart/form-data'
    }
  })
}
